import React from "react";
import ServicePolicyPage from "components/misc/ServicePolicyPage";

export default function PrivacyPolicy() {
  return <ServicePolicyPage type="privacy" />;
}
